import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postLogin = async (
  name: string,
  cpf: string,
  email: string,
  password: string
) => {
  const response = await axios.post(`${API_URL}/register`, {
    name,
    cpf,
    email,
    password,
  });
  return response.data;
};
export default postLogin;
